'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2019 Adobe Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _WAMConstants = require('../constants/WAMConstants');

var _CommonUtil = require('./CommonUtil');

var _CommonUtil2 = _interopRequireDefault(_CommonUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThorDetectUtil = function () {
	function ThorDetectUtil() {
		_classCallCheck(this, ThorDetectUtil);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
	}

	/**
  * Returns the AAM plugin installed on the current browser
  *
  * @returns AAM Plugin
  */


	// Singleton


	_createClass(ThorDetectUtil, [{
		key: 'getAAMPlugin',
		value: function getAAMPlugin() {
			var aamPlugin = null;

			if (navigator && navigator.plugins) {
				aamPlugin = Object.values(navigator.plugins).find(function (plugin) {
					return plugin && plugin.name && plugin.name.toLowerCase().indexOf('adobeaamdetect') > -1;
				});
			}

			if (!aamPlugin && _CommonUtil2.default.getBrowserType().name === 'IE') {
				try {
					aamPlugin = new ActiveXObject('AdobeAAMDetect.AdobeAAMDetect');
				} catch (e) {
					return null;
				}
			}

			return aamPlugin;
		}

		/**
   * Returns the version of the AAM plugin installed on the current browser
   *
   * @returns AAM Plugin version
   */

	}, {
		key: 'getAAMPluginVersion',
		value: function getAAMPluginVersion() {
			var aamVersion = null;
			var aamPlugin = null;
			// Win: Creative Cloud Desktop Plugin.v_2_0_0_0
			// Mac: A plugin to detect whether the Adobe Creative Cloud is installed on this machine.v_2_0_0_0
			if (navigator && navigator.plugins) {
				aamPlugin = Object.values(navigator.plugins).find(function (plugin) {
					return plugin && plugin.name && plugin.name.toLowerCase().indexOf('adobeaamdetect') > -1;
				});

				// Retrieve version info from description
				if (aamPlugin && aamPlugin.description) {
					aamVersion = aamPlugin.description.match(/[0-9]_[0-9]_[0-9]_[0-9]/i);
					if (aamVersion && aamVersion[0]) {
						aamVersion = aamVersion[0].replace(/_/g, '.');
					}
				}
			}

			// Win IE: x.0.0.0
			if (!aamPlugin && platform.name === 'IE') {
				try {
					aamPlugin = new ActiveXObject('AdobeAAMDetect.AdobeAAMDetect');
					if (aamPlugin && aamPlugin.version) {
						aamVersion = aamPlugin.version.match(/[0-9].[0-9].[0-9].[0-9]/i);
						if (aamVersion && aamVersion[0]) {
							aamVersion = aamVersion[0];
						}
					}
				} catch (e) {
					return null;
				}
			}

			return aamVersion;
		}

		/**
   * Tells whether the aamPlugin supports '&'. Versions 3.0.0.0 and above of Thor support using '&' to separate
   * parameters passed on the URL, just like http
   *
   * @returns true or false
   */

	}, {
		key: 'aamPluginSupportsAmpersand',
		value: function aamPluginSupportsAmpersand() {
			var aamVersion = this.getAAMPluginVersion();
			var ampersandSupportVersion = '3.0.0.0';
			return aamVersion && _CommonUtil2.default.compareVersionNumbers(aamVersion, ampersandSupportVersion) >= 0; // TODO
		}

		/**
   * Returns the promise that detects whether Thor is installed or not
   *
   * @returns Promise
   */

	}, {
		key: 'checkForThor',
		value: function checkForThor(wamArgs) {
			var _this = this;

			var checkForThorByLocalPingInParallel = function checkForThorByLocalPingInParallel(resolve, pingArgs) {
				// Set a timer so that image request times out after 10s
				var iter = 0;
				var ports = pingArgs && pingArgs.portToConnectWithThor && pingArgs.portToConnectWithThor.length > 0 ? pingArgs.portToConnectWithThor : ['15292', '35691', '57921'];
				var imageErrorCount = 0;
				var timer = void 0;
				var isPromiseResovled = false;
				// Function to get the url for the image request
				function getURL(port) {
					return 'https://detect.ffc.adobeoobe.com:' + port + '/cc.png?arg=' + Math.random();
				};
				function getHttpPingUrl(port, pingArgs) {
					if (pingArgs.pingType === _WAMConstants.pingType.httpPing) {
						return 'http://127.0.0.1:' + port + '/cc.png?type=' + pingArgs.pingType + '&arg=' + Math.random();
					} else if (pingArgs.pingType === _WAMConstants.pingType.httpPingInitiateWorkflow) {
						return 'http://127.0.0.1:' + port + '/cc.png?type=' + pingArgs.pingType + '&channelGuid=' + pingArgs.channelGuid + '&arg=' + Math.random();
					}
				};

				// function to clear the timer
				function clearTimer() {
					if (timer) {
						clearTimeout(timer);
						timer = null;
					}
				};

				timer = setTimeout(function () {
					resolvePromise(false);
				}, 10000);

				var resolvePromise = function resolvePromise(resolvedValue) {
					clearTimer();
					isPromiseResovled = true;
					resolve(resolvedValue);
				};

				var imageOnLoadFun = function imageOnLoadFun() {
					resolvePromise(true);
				};

				var imageOnErrorFun = function imageOnErrorFun() {
					imageErrorCount++;
					if (imageErrorCount === ports.length) {
						resolvePromise(false);
					}
				};

				var imageOnExceptionFun = function imageOnExceptionFun() {
					resolvePromise(false);
				};
				var images = [];
				while (iter < ports.length) {
					images[iter] = document.createElement('img');
					if (pingArgs && (pingArgs.pingType === _WAMConstants.pingType.httpPing || pingArgs.pingType === _WAMConstants.pingType.httpPingInitiateWorkflow)) {
						images[iter].referrerPolicy = 'unsafe-url'; // https://jira.corp.adobe.com/browse/CCD-9982
					}
					images[iter].src = pingArgs && pingArgs.pingType ? getHttpPingUrl(ports[iter], pingArgs) : getURL(ports[iter]);
					images[iter].onload = imageOnLoadFun;
					images[iter].onerror = imageOnErrorFun;
					images[iter].onexception = imageOnExceptionFun;
					if (isPromiseResovled) {
						return;
					}
					iter++;
				}
			};

			return new Promise(function (resolve) {
				var pingArgs = {};
				var v1WFPorts = ['15393', '35692', '57922'];
				var v2WFPorts = ['16494', '35693', '57923'];
				// Https WAM ping
				if (wamArgs && wamArgs.version === _WAMConstants.wamConnectWF.v1) {
					pingArgs.portToConnectWithThor = v1WFPorts;
					checkForThorByLocalPingInParallel(resolve, pingArgs);
				} else if (wamArgs && wamArgs.version === _WAMConstants.wamConnectWF.v2 && wamArgs.pingType === _WAMConstants.pingType.httpPing) {
					// http wam ping to check if v2 is supported in Thor 4.9+
					pingArgs.portToConnectWithThor = v2WFPorts;
					pingArgs.pingType = _WAMConstants.pingType.httpPing;
					checkForThorByLocalPingInParallel(resolve, pingArgs);
				} else if (wamArgs && wamArgs.version === _WAMConstants.wamConnectWF.v2 && wamArgs.pingType === _WAMConstants.pingType.httpPingInitiateWorkflow) {
					// http ping to pass on channelGuid and start Thor registration
					pingArgs.portToConnectWithThor = v2WFPorts;
					pingArgs.pingType = _WAMConstants.pingType.httpPingInitiateWorkflow;
					pingArgs.channelGuid = wamArgs.channelGuid;
					checkForThorByLocalPingInParallel(resolve, pingArgs);
				} else {
					// The AAM Plugin uses NPAPI architecture which is no longer supported by Google Chrome and Microsoft Spartan (Edge)
					if (_this.getAAMPlugin()) {
						resolve(true);
					} else {
						checkForThorByLocalPingInParallel(resolve);
					}
				}
			});
		}
	}]);

	return ThorDetectUtil;
}();

exports.default = new ThorDetectUtil();